import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "max-size p-relative" }

import { IonIcon } from "@ionic/vue";

import ButtonBase from "./ButtonBase.vue";

import { ION_VARIANT } from '@/types/enum/ionicEnum';

import { chevronBack, chevronForward } from "ionicons/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonNavigations',
  props: {
    isButtonBack: { type: Boolean },
    isButtonForward: { type: Boolean }
  },
  emits: ["back", "foward"],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["navigation-buttons px-2", [__props.isButtonBack ? 'ion-justify-content-between' : 'ion-justify-content-end']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.isButtonBack)
        ? (_openBlock(), _createBlock(ButtonBase, {
            key: 0,
            class: "round-button no-shadow circle-button back-navigation",
            color: _unref(ION_VARIANT).GREY_4,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                icon: _unref(chevronBack),
                class: "grey1-grey1-color"
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["color"]))
        : _createCommentVNode("", true),
      (__props.isButtonForward)
        ? (_openBlock(), _createBlock(ButtonBase, {
            key: 1,
            class: "round-button no-shadow circle-button forward-navigation",
            color: _unref(ION_VARIANT).GREY_4,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('foward')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                icon: _unref(chevronForward),
                class: "grey1-grey1-color"
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["color"]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})